import script from "./RoomDetailComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomDetailComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomDetailComponent.vue?vue&type=style&index=0&id=5afb05fc&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5afb05fc"]])

export default __exports__